module.exports = __webpack_public_path__ + "static/img/WLP1260-PF_A.6b0ef9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/WLP1260-PF_A.jpg
// module id = xh3V
// module chunks = 0